import apiConfig from 'src/integration/config/apiConfig';
import { useStore } from 'src/integration/store/store';
import useQueryKey from 'src/toolkit/utils/useQueryKey';
import useReactQueryJava from 'src/integration/api/useReactQueryJava';
import useErrorHandling from 'src/toolkit/utils/useErrorHandling';

const useFetchSites = () => {
  const { configStore, settingsStore } = useStore();
  const { setSiteList } = settingsStore;
  const { jwtToken } = configStore;
  const { logoutOnError } = useErrorHandling();

  const response = useReactQueryJava<SimpleObject, SimpleObject>({
    endpoint: apiConfig.api.endpointsJava.sites,
    queryKey: useQueryKey('sites', [jwtToken]),
    method: 'GET',
    opts: {
      enabled: !!jwtToken,
      refetchOnWindowFocus: false,
      onSuccess: (data: SimpleObject) => {
        setSiteList(data);
      },
    },
  });

  return {
    ...response,
  };
};

export default useFetchSites;
